import { StoreInfoWrapper } from "../Style/SearchStyles";
import { Cafe } from "../../../../api/types";
import { getDistanceKm, isVIP } from "../../../../utils/common";
import React, { useCallback } from "react";
import { useUI } from "../../NewSearch/Hook/UIContext";
import { useRecoilValue } from "recoil";
import { geoCoordState } from "../../../../recoil/geo";
import { useHistory } from "react-router-dom";
import OptimizedImage from "../../../../components/aws/OptimizedImage";
interface StoreItemProps {
  item: Cafe;
}

export const StoreItem = React.memo<StoreItemProps>(({ item }) => {
  const history = useHistory();
  const { latitude, longitude } = useRecoilValue(geoCoordState);
  const { showStoreList } = useUI();
  const handleClick = useCallback(() => {
    if (showStoreList) {
      if (isVIP(item.pubType)) {
        history.push(`/store/${item.id}?type=PREMIUM`);
      } else {
        history.push(`/store/${item.id}`);
      }
    }
  }, [showStoreList, history, item.id]);
  return (
    <StoreInfoWrapper onClick={handleClick}>
      <div className="cover">
        <OptimizedImage
          alt="cover"
          className="img"
          src={
            item?.images[0]
              ? item.images[0].imageUrl
              : "https://dfesoodpx4jgd.cloudfront.net/cafe/default.png"
          }
          aspectRatio={1} // 대략적인 카페 이미지 비율 (5:3)
          quality={85}
          maxWidth={300}
        />
      </div>
      <div className="bottom">
        <div className="title">{item.cafeName}</div>
        <div className="address">
          {item.newAddress} {item.detailAddress}
        </div>
        <div className="info-row">
          <div className="item">
            <img className="icon" src="/image-web/Icon/Heart/small.svg" />
            <span className="text">{item.likeCount}</span>
          </div>
          <div className="item">
            <img className="icon" src="/image-web/Icon/Map%20pin/small.svg" />
            <span className="text">
              {getDistanceKm(latitude, longitude, item.lat, item.lon)} km
            </span>
          </div>
        </div>
      </div>
    </StoreInfoWrapper>
  );
});
